








  import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
  import Util from '@/lib/util'
  import AbpBase from '@/lib/abpbase'
  import HzLetterView from "@/views/jm/jobdo/hz/hzletter.vue";

  @Component({
     components: {HzLetterView}
  })
export default class HZHomeView extends AbpBase {
     currview:string=""
     async created(){
        this.currview= this.$route.name;
     }
      @Watch('$route')
        routeChange(to:any){
          this.currview=to.name; 
        }
  }
